import React, { RefObject, useEffect, useRef } from 'react';

export function useReleaseFocusWhenPickerCloses(isOpen: boolean, isEnabled: boolean, popperRef: RefObject<HTMLElement>) {
  const wasOpenRef = useRef(isOpen);
  const isGivingFocusBackRef = useRef(false);
  const isPickedInPickerRef = useRef(false);

  useEffect(() => {
    const wasOpen = wasOpenRef.current;
    wasOpenRef.current = isOpen;
    const isPickedInPicker = isPickedInPickerRef.current;
    isPickedInPickerRef.current = false;
    if (!isEnabled || isOpen || !wasOpen || isPickedInPicker) {
      return undefined;
    }
    isGivingFocusBackRef.current = true;
    // MUI X focuses the field again in a timeout queued right after this effect, so the window closes one timeout later.
    let id = window.setTimeout(() => {
      id = window.setTimeout(() => {
        isGivingFocusBackRef.current = false;
      }, 0);
    }, 0);
    return () => {
      window.clearTimeout(id);
      isGivingFocusBackRef.current = false;
    };
  }, [isOpen, isEnabled]);

  function keepFocusAfterPick() {
    isPickedInPickerRef.current = true;
  }

  function handleFieldFocus(event: React.FocusEvent<HTMLInputElement>) {
    if (!isGivingFocusBackRef.current) {
      return;
    }
    isGivingFocusBackRef.current = false;
    const previous = event.relatedTarget;
    if (previous instanceof HTMLElement && popperRef.current?.contains(previous)) {
      return;
    }
    if (previous instanceof HTMLElement) {
      previous.focus();
    } else {
      event.currentTarget.blur();
    }
  }

  return { handleFieldFocus, keepFocusAfterPick };
}
